import Vue from 'vue'
import App from './App.vue'
import router from './router/index'

const mountEl = document.querySelector('#magazineTypeApp') as HTMLElement

const install = (mountEl: HTMLElement) => {
  if (!mountEl) {
    return false
  }

  new Vue({
    router,
    render: h => h(App, {
      props: {}
    })
  }).$mount(mountEl)
}
install(mountEl)
